// extracted by mini-css-extract-plugin
module.exports = {"cell":"CartCard-Cell-module--cell--1lKPv","main":"CartCard-Cell-module--main--3wTck","title":"CartCard-Cell-module--title--1aQHe","price":"CartCard-Cell-module--price--mgJJk"};